const createAdVideoElement = (contentDocument = document) => {
  const video = contentDocument.createElement('VIDEO');

  video.setAttribute('playsinline', 'true');
  video.muted = true;
  video.style.width = '100%';
  video.style.height = '100%';

  return video;
};

export default createAdVideoElement;
